<div class="container-fluid" >
  <div  style="display: inline;block-size: 10%;">
  <!--Header-->
    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 15px;">
       <div class="col-md-6 col-sm-6 lblHeader newHeader" style="display: inline-block;padding: 0px;">
          <h2 style="font-size: 25px;"> Product-wise Manufacturing Analysis </h2>
      </div>
      <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
        <span *ngIf="dataSource.data.length > 0"  class="search">
          <span class="fa fa-search"></span>
          <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
            (keyup)="applyFilter($event)" #input
            style="text-align: left;display: inline-block; background-color: white !important; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 31px !important;"
            type="text">
        </span>
        <span *ngIf="dataSource.data.length > 0" (click)="exportToExcelActivities()" class="orangeButton"
          style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
          <span>
            <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
          </span>
        </span>


        <div style="display: inline-block; padding: 0px;" title="Back to Production Dashboard">
          <span class="darkBlueButton"
              style="font-size: 13px; display: inline-block; padding: 4px 10px; margin-left: 10px;"
              (click)="backBtn()">
              <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Production
          </span>
      </div>

      </div>
    </div>
  </div>

  <!--Filter-->
  <div class="col-md-12 col-xs-12 col-sm-12 pad0" style="margin-bottom: 25px;">
      <div style="display:inline-block ;">
          <div style="display: inline-block; padding-left: 20px;" >
              <label  style="font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                  for="sel1">Month : </label>
          </div>
      
          <div style="display: inline-block;margin-left: 10px;">
            <select  class="form-control bgwhite formCtlFltr " style="box-shadow: none;width: 100px;cursor: pointer; font-size: 13px;" [(ngModel)]="monthDisplay" 
            (change) ="trasYearChange()">
            <option *ngFor="let i of months;">{{i.display}}</option>
          </select>
        </div>
        </div>
  </div>

    <!--Data Table-->
  <div class="wrapper" style="text-overflow: ellipsis; white-space: nowrap;" #mtlAviaTable>
    <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow" style="width: 95%;">
      <table *ngIf="dataSource.data.length > 0" mat-table [dataSource]="dataSource" matSort style="border-radius: 3px;">
      
          <ng-container matColumnDef="PrdName" style="cursor: pointer;">
      
          <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Product</label>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 15% !important;"> {{element.PrdName}} </td>
          <!-- <td mat-cell *matCellDef="let element" style="width: 25% !important;"> Paneer Tikka</td> -->
          </ng-container>
      
          <ng-container matColumnDef="PrdCode">
          <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Code</label>
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: left; width: 10%;"> {{element.PrdCode}} </td>
          <!-- <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> PTM</td> -->

          </ng-container>
      
          <ng-container matColumnDef="CntJobs">
              <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Jobs</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: right; width: 1%; padding-right: 27px !important;"> {{element.CntJobs}} </td>
              <!-- <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> 5 </td> -->

          </ng-container>

          <ng-container matColumnDef="StdPrd">
              <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Std Period</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: left; width: 0%;padding-right: 25PX !IMPORTANT;"> {{element.StdPrd}} {{element.StdPrd == 1 ? 'day' : 'days'}} </td>
              <!-- <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> 3 days </td> -->
          </ng-container>

          <ng-container matColumnDef="AvgPrd">
              <th class="header header-Table" style="cursor: pointer; " mat-header-cell *matHeaderCellDef mat-sort-header>
              <label>Avg Period</label>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: left; width: 1%;padding-right: 25PX !IMPORTANT;"> {{element.AvgPrd}} {{element.AvgPrd == 1 ? 'day' : 'days'}}</td>
              <!-- <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> 4.5 days </td> -->

          </ng-container>
          <ng-container matColumnDef="OnTime">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
            <label>Punctuality</label>
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: right; width: 1%;padding-right: 25PX !IMPORTANT;"> {{element.OnTime}} %</td>
            <!-- <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> 4.5 days </td> -->

        </ng-container>
      
          <ng-container matColumnDef="LaunchQty">
          <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
              <label> Launch </label>
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: right; width: 1%;padding-right: 29PX !IMPORTANT;"> {{element.LaunchQty}} </td>
          <!-- <td mat-cell *matCellDef="let element"> 80% </td> -->

          </ng-container>
        
          <ng-container matColumnDef="ComplnQty">
                  <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                  <label> Completion </label>
                  </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right; width: 0%;padding-right: 25PX !IMPORTANT;"> {{element.ComplnQty}} </td>
                  <!-- <td mat-cell *matCellDef="let element"> 45 </td> -->

          </ng-container>
          <ng-container matColumnDef="Unit">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> Unit </label>
            </th>
            <td mat-cell *matCellDef="let element"style="text-align: left; width: 7%;padding-right: 25PX !IMPORTANT;" > {{element.Unit}} </td>
            <!-- <td mat-cell *matCellDef="let element"> pcs </td> -->
        </ng-container>
        <ng-container matColumnDef="Rejection">
                <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label> Rejection </label>
                </th>
                <td mat-cell *matCellDef="let element"style="text-align: right; width: 1%;padding-right: 37px !IMPORTANT;"> {{element.Rejection}} %</td>

        </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
      </table>
       <!-- Angular 8 pagination -->
       <mat-paginator *ngIf="dataSource.data.length > 0" [pageSizeOptions]="[10, 15]" showFirstLastButtons>
      </mat-paginator>
     </div>
  </div>
  
  <div *ngIf="materialAvailabilityList.length == 0">
    <div style="margin:15px; margin-top: 0px" class="nrf brdrRadius3">No records found.</div>
  </div>
</div>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>